/**
 * «oggi», «ieri», «2 giorni fa», «12 ago».
 *
 * Il confronto è per **giorno di calendario**, non per ore trascorse: una spesa
 * di ieri sera alle 23 e una di stamattina alle 7 distano nove ore, ma per chi
 * legge sono ieri e oggi. Con la differenza in ore direbbe «0 giorni fa» a
 * entrambe.
 */
export function relativeDay(iso: string, now = new Date()): string {
  const date = new Date(iso);
  const days = Math.round((startOfDay(now).getTime() - startOfDay(date).getTime()) / 86_400_000);

  if (days <= 0) return "oggi";
  if (days === 1) return "ieri";
  // Oltre la settimana il conteggio dei giorni smette di dire qualcosa: «23
  // giorni fa» si ritraduce in una data, tanto vale darla.
  if (days <= 7) return `${days} giorni fa`;

  return date.toLocaleDateString("it-IT", { day: "numeric", month: "short" }).replace(".", "");
}

function startOfDay(date: Date): Date {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}
